
document.addEventListener("DOMContentLoaded", function () {

    let currentDateMobile = new Date();
    let selectedDateMobile = null; // no selected date on first open

    initCalendar();

    // Cart events → reset month & re-render calendar
    document.addEventListener("cart:updated", function () {
        console.log("Cart Updated → Resetting Month");
        currentDateMobile = new Date();
        renderMobileCalendar();
    });

    document.body.addEventListener("ajaxCart:updated", function () {
        console.log("AJAX Cart Updated → Resetting Month");
        currentDateMobile = new Date();
        renderMobileCalendar();
    });

    function initCalendar() {
        window.renderMobileCalendar = function() {
            const calendarDays = document.getElementById("calendarDays-mobiledwr");
            const monthYear = document.getElementById("monthYear-mobiledwr");
            const selectedDateInput = document.getElementById("selectedDate-mobiledrawer");

            if (!calendarDays || !monthYear || !selectedDateInput) return;

            let year = currentDateMobile.getFullYear();
            let month = currentDateMobile.getMonth();

            monthYear.textContent = currentDateMobile.toLocaleDateString("en-US", { month: "long", year: "numeric" });
            calendarDays.innerHTML = "";

            let firstDay = new Date(year, month, 1).getDay();
            firstDay = (firstDay === 0) ? 6 : firstDay - 1;
            let lastDate = new Date(year, month + 1, 0).getDate();

            for (let i = 0; i < firstDay; i++) {
                let emptyDay = document.createElement("div");
                emptyDay.classList.add("day", "inactive");
                calendarDays.appendChild(emptyDay);
            }

            let disableNextDate = null;
            if (isDuctlessInCart()) {
                let today = new Date(); today.setHours(0,0,0,0);
                disableNextDate = new Date(today);
                disableNextDate.setDate(disableNextDate.getDate() + 1);
                console.log("ductless cart item found → disabling next date:", disableNextDate);
            }

            for (let i = 1; i <= lastDate; i++) {
                let day = document.createElement("div");
                day.classList.add("day");
                day.textContent = i;

                let dateValue = new Date(year, month, i);
                let today = new Date(); today.setHours(0,0,0,0);

                let sameSelected = selectedDateMobile && dateValue.toDateString() === selectedDateMobile.toDateString();

                if (dateValue < today || (disableNextDate && dateValue.toDateString() === disableNextDate.toDateString())) {
                    day.classList.add("inactive");
                    day.style.pointerEvents = "none";
                    day.style.color = "#949494";
                } else {
                    day.setAttribute("data-date", formatDate(dateValue));

                    day.addEventListener("click", function () {
                        selectedDateMobile = dateValue;

                        const formatted = formatDateDMY(selectedDateMobile);
                        selectedDateInput.value = formatted;
                        selectedDateInput.setAttribute('value', formatted);

                        // ===============================
                        // ADDED → toggle .today_date class
                        toggleTodayClass(selectedDateMobile);
                        // ===============================

                        document.querySelectorAll("#calendarDays-mobiledwr .day").forEach(d => {
                            d.classList.remove("active");
                            d.style.backgroundColor = "";
                            d.style.color = "";
                        });

                        day.classList.add("active");
                        day.style.backgroundColor = "#70BC0E";
                        day.style.color = "#ffffff";

                        $(".calendar-mobiledrawer").slideUp();
                    });

                    day.addEventListener("mouseenter", () => {
                        if (!day.classList.contains("active")) {
                            day.style.backgroundColor = "#70BC0E";
                            day.style.color = "#ffffff";
                        }
                    });

                    day.addEventListener("mouseleave", () => {
                        if (!day.classList.contains("active")) {
                            day.style.backgroundColor = "";
                            day.style.color = "";
                        }
                    });
                }

                if (sameSelected) {
                    day.classList.add("active");
                    day.style.backgroundColor = "#70BC0E";
                    day.style.color = "#ffffff";
                }

                calendarDays.appendChild(day);
            }

            setTimeout(() => {
                const activeDay = document.querySelector("#calendarDays-mobiledwr .day.active");
                if (activeDay) {
                    activeDay.style.backgroundColor = "#70BC0E";
                    activeDay.style.color = "#ffffff";
                }
            }, 50);

            console.log("Calendar rendered:", calendarDays.children.length);
        }

        window.prevMonthMobiledwr = function () {
            currentDateMobile = new Date(currentDateMobile.getFullYear(), currentDateMobile.getMonth() - 1, 1);
            renderMobileCalendar();
        };

        window.nextMonthMobiledwr = function () {
            currentDateMobile = new Date(currentDateMobile.getFullYear(), currentDateMobile.getMonth() + 1, 1);
            renderMobileCalendar();
        };
    }

    function isDuctlessInCart() {
        const cartItems = document.querySelectorAll(".cart-item, .cart__item, .cart-items li");
        return Array.from(cartItems).some(item =>
            item.textContent.toLowerCase().includes("ductless heat pump")
        );
    }

    function formatDate(date) {
        let yyyy = date.getFullYear();
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    function formatDateDMY(date) {
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }

    // =========================================
    // ADDED → add/remove .today_date on calendar
    function toggleTodayClass(selectedDate) {
        const cal = document.querySelector(".custom-celander");
        if (!cal) return;

        const today = new Date();
        today.setHours(0,0,0,0);

        const sel = new Date(selectedDate);
        sel.setHours(0,0,0,0);

        if (sel.getTime() === today.getTime()) {
            cal.classList.add("today_date");
        } else {
            cal.classList.remove("today_date");
        }
    }
    // =========================================

    function setupCalendarToggle() {
        $(document).off('click', '.selectedDate-mobiledrawer-2').on('click', '.selectedDate-mobiledrawer-2', function() {
            console.log("Opening Calendar");
            currentDateMobile = new Date();
            renderMobileCalendar();
            $(".calendar-mobiledrawer").stop(true,true).slideDown(300);
        });
    }

    setupCalendarToggle();

    const calendarDrawer = document.querySelector(".calendar-mobiledrawer");
    if (calendarDrawer) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "style" && calendarDrawer.style.display === "none") {
                    console.log("Calendar Closed → Resetting Month");
                    currentDateMobile = new Date();
                }
            });
        });
        observer.observe(calendarDrawer, { attributes: true, attributeFilter: ["style"] });
    }

    document.body.addEventListener("click", function(e){
        const drawerClose = e.target.closest(".drawer__close");
        const drawerOverlay = e.target.closest("#CartDrawer-Overlay");
        if(drawerClose || drawerOverlay){
            const calendar = document.querySelector(".calendar-mobiledrawer");
            if(calendar){
                calendar.style.display = "none";
                console.log("Calendar hidden due to drawer close");
            }
        }
    });

});

document.addEventListener('DOMContentLoaded', function () {

  function hasNonGoProtectItem() {
    const cartItems = document.querySelectorAll('tr.cart-item');
    let foundNonGoProtect = false;
    cartItems.forEach(item => {
      if (!item.querySelector('.go-protect-flag')) foundNonGoProtect = true;
    });
    return foundNonGoProtect;
  }

  function attachValidation() {
    const form = document.querySelector('form#CartDrawer-Form');
    const dateInput = document.getElementById('selectedDate-mobiledrawer');
    const timeSlot = document.getElementById('InstallationTime-mobile-dwr');
    const errorDiv = document.querySelector('.error_massage-mobiledwr');
    const dateTimeWrapper = document.querySelector('.drawer__inner .custom-celander');

    if (!form || !dateInput || !timeSlot || !dateTimeWrapper) return;

    // 🚫 Disable native HTML5 validation
    form.setAttribute('novalidate', 'true');

    const isRequired = hasNonGoProtectItem();

    // Show/hide calendar
    if (isRequired) {
      dateTimeWrapper.style.display = '';
    } else {
      dateTimeWrapper.style.display = 'none';
      dateInput.value = '';
      timeSlot.value = '';
      dateInput.classList.remove('input-error');
      timeSlot.classList.remove('input-error');
      if (errorDiv) errorDiv.classList.remove('show');
    }

    if (form.dataset.validationAttached === "true") return;
    form.dataset.validationAttached = "true";

    form.addEventListener('submit', function (event) {
      if (!hasNonGoProtectItem()) return;

      let valid = true;

      if (!dateInput.value.trim()) {
        dateInput.classList.add('input-error');
        valid = false;
      } else dateInput.classList.remove('input-error');

      if (!timeSlot.value.trim()) {
        timeSlot.classList.add('input-error');
        valid = false;
      } else timeSlot.classList.remove('input-error');

      if (!valid) {
        event.preventDefault(); // Stop native submit
        if (errorDiv) {
          errorDiv.textContent = 'Please select Date and Time both';
          errorDiv.classList.add('show');
          setTimeout(() => {
            errorDiv.textContent = '';
            errorDiv.classList.remove('show');
          }, 3000);
        }
      }
    });

    dateInput.addEventListener('input', () => {
      dateInput.classList.remove('input-error');
      if (errorDiv) errorDiv.classList.remove('show');
    });

    timeSlot.addEventListener('change', () => {
      timeSlot.classList.remove('input-error');
      if (errorDiv) errorDiv.classList.remove('show');
    });

  }

  attachValidation();

  const observer = new MutationObserver(() => attachValidation());
  observer.observe(document.body, { childList: true, subtree: true });

});
